import { SandboxDomainError } from '../errors';
import { SandboxSession, SandboxState } from '../types';
import { getHost } from './hosts';

export interface StartSessionInput {
  host_id: number;
  client_uuid?: string | null;
  post_paid?: boolean;
  tariff_id?: number;
  payment_id?: number;
}

export const startSessionAction = (
  state: SandboxState,
  input: StartSessionInput,
  timestamp: string
): SandboxSession => {
  const host = getHost(state, input.host_id);
  if (!host.online || host.in_service)
    throw new SandboxDomainError('Хост недоступен для запуска сессии');
  if (
    state.sessions.some(
      (session) => session.host_id === host.id && session.status === 'ACTIVE'
    )
  ) {
    throw new SandboxDomainError('На хосте уже есть активная сессия');
  }
  if (
    input.client_uuid &&
    !state.clients.some((client) => client.uuid === input.client_uuid)
  ) {
    throw new SandboxDomainError('Клиент не найден');
  }
  const postpaid = Boolean(input.post_paid);
  const tariff = input.tariff_id
    ? state.tariffs.find((item) => item.id === input.tariff_id)
    : postpaid
    ? state.tariffs.find((item) => item.per_minute)
    : undefined;
  if (input.tariff_id && !tariff)
    throw new SandboxDomainError('Тариф не найден');
  if (postpaid && !tariff)
    throw new SandboxDomainError('Поминутный тариф не найден');
  const duration = postpaid ? 0 : tariff?.duration ?? 3600;
  const session: SandboxSession = {
    __typename: 'ClientSessionOverview',
    origin: 'runtime',
    id: state.nextSessionId++,
    client_uuid: input.client_uuid ?? null,
    host_id: host.id,
    host_ids: [host.id],
    postpaid,
    status: 'ACTIVE',
    started_at: timestamp,
    finished_at: postpaid
      ? null
      : new Date(Date.parse(timestamp) + duration * 1000).toISOString(),
    duration,
    elapsed: 0,
    time_left: duration,
    total_cost: postpaid ? 0 : tariff?.cost ?? 0,
    seances: [
      {
        id: state.nextSessionId * 10,
        status: 'ACTIVE',
        tariff: {
          id: tariff?.id ?? 0,
          title: tariff?.title ?? 'Постоплата',
          kind: postpaid ? 'PER_MINUTE' : tariff?.kind ?? 'PACKET',
        },
      },
    ],
    payment_id: input.payment_id,
  };
  state.sessions.push(session);
  return session;
};

export const moveSessionAction = (
  state: SandboxState,
  id: number,
  hostId: number
): SandboxSession => {
  const session = state.sessions.find(
    (item) => item.id === id && item.status === 'ACTIVE'
  );
  if (!session) throw new SandboxDomainError('Активная сессия не найдена');
  const target = getHost(state, hostId);
  if (
    !target.online ||
    target.in_service ||
    state.sessions.some(
      (item) => item.host_id === hostId && item.status === 'ACTIVE'
    )
  ) {
    throw new SandboxDomainError('Новый хост занят или недоступен');
  }
  session.host_ids.push(hostId);
  session.host_id = hostId;
  return session;
};

export const stopSessionAction = (
  state: SandboxState,
  id: number,
  timestamp: string
): SandboxSession => {
  const session = state.sessions.find(
    (item) => item.id === id && item.status === 'ACTIVE'
  );
  if (!session) throw new SandboxDomainError('Активная сессия не найдена');
  session.status = 'FINISHED';
  session.finished_at = timestamp;
  session.seances.forEach((seance) => (seance.status = 'FINISHED'));
  return session;
};
